import axios from "axios";
//GET ALL CARCATAGORY BY COUNTRY
export const GET_ALL_INVOICES_COUNTER = "GET_ALL_INVOICES_COUNTER";
export const GET_ALL_INVOICES_COUNTER_LOADING =
"GET_ALL_INVOICES_COUNTER_LOADING";
export const GET_ALL_INVOICES_COUNTER_LOADING_FAILED =
"GET_ALL_INVOICES_COUNTER_LOADING_FAILED";

// HELPER ACTIONS CREATORS
//************************************** /

export const invoiceCounterLoading = ms => ({
    type: GET_ALL_INVOICES_COUNTER_LOADING,
    payload: ms
    });
    
    export const invoiceCounterLoadingFailed = ms => ({
    type: GET_ALL_INVOICES_COUNTER_LOADING_FAILED,
    payload: ms
    });

// RIDER PHINE NUBER
export function invoiceCounter() {
  /* ${process.env.REACT_APP_FILE}/accountRoutes/api/v1/caseQuotations/getCountOfQuotation  */
    const request = axios.get(
      `${process.env.REACT_APP_FILE}/accountRoutes/api/v1/caseInvoices/getCountOfInvoices`,
      {
        headers: { 'Authorization': 'bearer ' +localStorage.accountantToken}
      });

    return dispatch => {

    dispatch(invoiceCounterLoading());
 
    request
    .then(response => {   
      console.log(response,"response")   
    if (response.status == 200) {
    dispatch({
    type: GET_ALL_INVOICES_COUNTER,
    payload: response.data
    });
  
    } else {
      
    throw new Error(JSON.stringify(response.data.response.msg));
    }
    })
    .catch(error => {
        
    if (error.response) {
    if (error.response.status == "404") {
        console.log(error.response)
    dispatch(
        invoiceCounterLoadingFailed(error.response.data.message)
    );
    } else {
    dispatch(invoiceCounterLoadingFailed(error.response.data.message));
    }
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    } else if (error.request) {
    /*
    * The request was made but no response was received, `error.request`
    * is an instance of XMLHttpRequest in the browser and an instance
    * of http.ClientRequest in Node.js
    */
    dispatch(invoiceCounterLoadingFailed(error.request));
    
    console.log(error.request);
    } else {
    // Something happened in setting up the request and triggered an Error
    console.log("Error", error.message);
    dispatch(invoiceCounterLoadingFailed(error.message));
    }
    console.log(error);
    });
    };
    }


